import React, { useEffect, useState } from "react";
import { useProject } from "@utils/useProject";

interface Project {
  id: number;
  title: string;
  description: string;
  files_count: number;
  updated: string;
  icon: string;
}

const ProjectsOverviewPage: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [reportsCount, setReportsCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const { getDashboardInfo } = useProject();

  const getProjects = async () => {
    try {
      setLoading(true);
      const resp = await getDashboardInfo();

      const projects = resp.projects.map((project: any) => ({
        id: project.id,
        title: project.name,
        description: project.description,
        files_count: 0,
        updated: project.updated_at,
        icon: project.icon,
      }));

      setReportsCount(resp.reports_count);
      setProjects(projects);
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjects();
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-3xl font-semibold text-gray-700 mb-6">
        Projects overview
      </h1>

      <div className="flex">
        <div className="flex flex-col w-3/4 space-y-4 p-4">
          <div className="flex space-x-4">
            <div className="bg-blue-50 border-blue-700 border-2 rounded-md flex-1 p-4">
              <h3 className="text-gray-500">No. of Projects</h3>
              <p className="text-2xl font-semibold">{projects.length}</p>
            </div>
            <div className="border-green-600 border-2 bg-emerald-50 rounded-md flex-1 p-4">
              <h3 className="text-gray-500">No. of Reports</h3>
              <p className="text-2xl font-semibold">{reportsCount}</p>
            </div>
          </div>

          <div className="bg-gray-200 border-2 border-gray-300 rounded-md h-60 flex items-center justify-center">
            <p className="text-gray-500">Map Placeholder</p>
          </div>

          <div className="bg-white border-2 border-gray-300 rounded-md">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b-2 border-gray-300 rounded-md">
                  <th className="p-4 text-gray-500">Project Name</th>
                  <th className="p-4 text-gray-500">End Date</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b hover:bg-gray-50">
                  <td className="p-4">Increasing Woman Literacy</td>
                  <td className="p-4">2023-01-01</td>
                </tr>
                <tr className="border-b hover:bg-gray-50">
                  <td className="p-4">Increasing Access to Clean Water</td>
                  <td className="p-4">2023-01-02</td>
                </tr>
                <tr className="border-b hover:bg-gray-50">
                  <td className="p-4">Improving Child Health</td>
                  <td className="p-4">2023-01-03</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="p-4">Promoting Renewable Energy</td>
                  <td className="p-4">2023-01-03</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Right Section - Updates */}
        <div className="w-1/2 p-4">
          <div className="bg-white border-2 border-gray-300 rounded-md p-4">
            <h2 className="text-gray-500 mb-4 font-semibold text-xl">
              Updates
            </h2>
            <ul className="space-y-4 overflow-y-scroll">
              <li>
                <p className="text-gray-700 font-medium">
                  Jane Smith{" "}
                  <span className="text-sm text-gray-500">2023-01-01</span>
                </p>
                <p className="text-sm text-gray-700">
                  Created new report for project name Increasing Child Health
                </p>
              </li>
              <li>
                <p className="text-gray-700 font-medium">
                  Jane Smith{" "}
                  <span className="text-sm text-gray-500">2023-01-01</span>
                </p>
                <p className="text-sm text-gray-700">
                  Created new report for project name Increasing Child Health
                </p>
              </li>
              <li>
                <p className="text-gray-700 font-medium">John Doe</p>
                <p className="text-sm text-gray-500">2023-01-02</p>
                <p className="text-sm text-blue-500">
                  Deleted document from project Increasing Access to Clean Water
                </p>
              </li>
              <li>
                <p className="text-gray-700 font-medium">Alice Johnson</p>
                <p className="text-sm text-gray-500">2023-01-03</p>
                <p className="text-sm text-blue-500">
                  Changed report draft for project Increasing Child Health
                </p>
              </li>
              <li>
                <p className="text-gray-700 font-medium">Bob Brown</p>
                <p className="text-sm text-gray-500">2023-01-04</p>
                <p className="text-sm text-blue-500">
                  Added a member to project Increasing Access to Clean Water
                </p>
              </li>
              <li>
                <p className="text-gray-700 font-medium">Eva Davis</p>
                <p className="text-sm text-gray-500">2023-01-05</p>
                <p className="text-sm text-blue-500">
                  Created new template under Promoting Renewable Energy
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsOverviewPage;
